<script>
const Performance = {
    id: null,
    hash: null,
    is_heading: false,
    is_footer: false,
    name: null,
    number: '',
    weight: 0,
    target: null,
    target_monthly: 0,
    target_ongoing: 0,
    total_target: 0,
    total_yield: 0,
    percentage_month: 0,
    percentage_project: 0,
    predicate: 1,
    background: null,
    achievement: { status: 'waiting', target_yield: 0, total_yield: 0 }
}

export default {
    props: {
        aspect: {
            type: String,
            default: 'BRE'
        },
        type: {
            type: String,
            default: 'RLZ'
        },
        catCode: {
            type: String,
            required: true
        },
        title: {
            type: String,
            default: ''
        },
        month: {
            type: Object,
            required: true
        }
    },
    computed: {
        tableData() {
            if (this.objectives.length > 0) {
                let idx = 0, collection = [], heading = 0, number = 0, vm = this
                let curr = this.month
                let keyResult = ''

                this.objectives.forEach(function (item, index) {

                    idx++
                    if (heading !== item.indicator.name) {
                        keyResult = item.indicator.name
                        collection.push(Object.assign(Object.create(Performance), {
                            id: idx,
                            is_heading: true,
                            name: item.indicator.name,
                        }))

                        number = 0
                        heading = item.indicator.name
                        idx++
                    }

                    let achievement = _.has(vm.achievements, item.hash)
                        ? _.find(vm.achievements[item.hash], {month: vm.currentSelectedMonth.format('YYYYMM')})
                        : { status: 'waiting', target_yield: 0, total_yield: 0, file_path: null, evaluation: vm.aspect === 'BRE' ? 1 : 3 }

                    number++

                    collection.push(Object.assign(Object.create(Performance), {
                        id: idx,
                        index,
                        number,
                        name: item.objective,
                        target: item.config.description,
                        target_monthly: item.config.target.monthly_target,
                        target_ongoing: Math.round(item.config.target['target_' + curr.format('YYYYMM')]),
                        total_target: item.config.target_amount,
                        target_yield: achievement.target_yield,
                        total_yield: achievement.total_yield,
                        percentage_month: Math.round(achievement.target_yield / Math.round(item.config.target['target_' + curr.format('YYYYMM')]) * 100),
                        percentage_project: Math.round((achievement.total_yield / item.config.target_amount)  * 100),
                        weight: Math.round(item.config.weight * 100),
                        aspect_weight: item.config.aspect_weight,
                        rate_weight: Math.round(item.config.weight * 100)*achievement.evaluation/100,
                        //score_weight: Math.round(item.config.weight * 100)*achievement.evaluation/100*item.config.aspect_weight,
                        //score_weight: item.config.weight*achievement.evaluation*item.config.aspect_weight,
                        score_weight: item.config.weight*achievement.evaluation*(40/100),
                        predicate: achievement.evaluation,
                        key_result: keyResult,
                        wom: item.config.wom,
                        achievement
                    }))
                })

                collection.push( Object.assign(Object.create(Performance), {
                    id: idx + 1,
                    is_footer: true,
                    weight: collection.reduce((a, b) => a + b.weight, 0),
                    name: 'Total',
                    rate_weight: collection.reduce((a, b) => a + (b.achievement.status != 'approved' ? 0 : b.rate_weight) , 0),
                    score_weight: collection.reduce((a, b) => a + (b.achievement.status != 'approved' ? 0 : b.score_weight), 0),
                }))

                if(this.aspect === 'BRE'){
                    let total = collection.filter(function (el) {
                        return el.is_footer == true;
                    });
                    this.$emit("breTotal", total[0].score_weight*(70/100));
                }else if(this.aspect === 'BPR'){
                    let total = collection.filter(function (el) {
                        return el.is_footer == true;
                    });
                    this.$emit("bprTotal", total[0].score_weight);
                }

                return collection
            }
            return []
        },
        defaultMonth() {
            let current = this.moment()

            if (current.isBetween(this.dateStart, this.dateEnd, 'month'))
            {
                current.subtract(1, 'months')

                if (current.isSameOrBefore(this.dateStart, 'month')) {
                    return current
                } else if (current.isSameOrAfter(this.dateEnd, 'month')) {
                    return this.dateEnd
                }
                return current
            } else if (current.isSameOrBefore(this.dateStart, 'month')) {
                return this.dateStart
            }

            return this.dateEnd
        },
        currentSelectedMonth() {
            return this.month === null ? this.defaultMonth : this.month
        },
    },
    data: () => ({
        objectives: [],
        achievements: {},
        loading: false,
    }),
    created() {
        this.dateStart = this.moment(this.$laravel.training.date_start)
        this.dateEnd = this.moment(this.$laravel.training.date_end)

        this.getObjectives()
    },
    methods: {
        setData(data) {
            this.achievements = data.achievements
            this.objectives = data.objectives
        },
        getObjectives() {
            this.loading = true
            this.$http
                .get(this.routeUri('api.performance.implementation'), {
                    params: {
                        cat: this.catCode,
                    }
                })
                .then(response => this.setData(response.data))
                .catch(err => this.handleXhrError(err))
                .finally(() => this.loading = false)
        },
    },
}
</script>

<template>
    <div>
        <a-card type="inner" size="small">
           <a-skeleton :loading="loading" active>
               <performance-report-table :type="type" :data="tableData" :title="title" />
           </a-skeleton>
        </a-card>
    </div>
</template>
